// Role constants
export const ROLE_ADMIN = 'Admin';
export const ROLE_ADMIN_ENTITY = 'AdminEntity';
export const ROLE_MINISTRY_REVIEWER = 'MinistryReviewer';
export const ROLE_INITIAL_INSPECTION_APPROVER = 'InitialInspectionApprover';
export const ROLE_DETAILED_INSPECTION_APPROVER = 'DetailedInspectionApprover';
export const ROLE_INITIAL_EVALUATOR = 'InitialEvaluator';
export const ROLE_DETAILED_EVALUATOR = 'DetailedEvaluator';
export const ROLE_ENTITY_REVIEWER = 'EntityReviewer';

// Route role requirements mapping
export const REQUIRED_ROLES = {
  statistics: [ROLE_ADMIN, ROLE_ADMIN_ENTITY],
  'general-settings': [ROLE_ADMIN],
  'buildings-settings': [ROLE_ADMIN, ROLE_ADMIN_ENTITY],
  'buildings-classification': [ROLE_ADMIN],
  'org-structures': [ROLE_ADMIN],
  'elements-classifications': [ROLE_ADMIN],
  blanks: [ROLE_ADMIN, ROLE_ADMIN_ENTITY, ROLE_DETAILED_EVALUATOR],
  users: [ROLE_ADMIN, ROLE_ADMIN_ENTITY],
  'inspection-requests': [
    ROLE_ADMIN,
    ROLE_ADMIN_ENTITY,
    ROLE_MINISTRY_REVIEWER,
    ROLE_INITIAL_INSPECTION_APPROVER,
    ROLE_INITIAL_EVALUATOR,
    ROLE_ENTITY_REVIEWER
  ],
  'detailed-inspection-requests': [
    ROLE_ADMIN,
    ROLE_ADMIN_ENTITY,
    ROLE_MINISTRY_REVIEWER,
    ROLE_DETAILED_INSPECTION_APPROVER,
    ROLE_DETAILED_EVALUATOR,
    ROLE_ENTITY_REVIEWER
  ],
  'manage-inspections-requests': [ROLE_ADMIN, ROLE_ADMIN_ENTITY],
  'manage-initial-inspections-requests': [ROLE_ADMIN, ROLE_ADMIN_ENTITY],
  'manage-detailed-inspections-requests': [ROLE_ADMIN, ROLE_ADMIN_ENTITY],
  'initial-evaluation': [ROLE_ADMIN],
  'detailed-evaluation': [ROLE_ADMIN],
  'logs': [ROLE_ADMIN],
  'audit-trail': [ROLE_ADMIN]
};



